<template>
    <div>
        <b-card class="border-silver p-1">
            <p v-if="price.type === 'gram_offer' || price.type === 'gram'">{{price.title}}</p>
            <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center px-0">
                    Prise
                    <template v-if="price.type === 'single_price_offer' || price.type === 'gram_offer'">
                                <span>
                                    <span class="mr-2" style="text-decoration: line-through">{{price.price}} €</span>
                                    <span class="text-danger">{{price.priceSell}} €</span>
                                </span>
                    </template>
                    <template v-else>
                        <span>{{price.price}} €</span>
                    </template>
                </b-list-group-item>
                <b-list-group-item
                        v-if="price.type === 'single_price_offer' || price.type === 'gram_offer'"
                        class="d-flex justify-content-between align-items-center px-0">
                    Rabbat Percent
                    <span>{{price.offerDiscount}} %</span>
                </b-list-group-item>
                <b-list-group-item
                        v-if="price.type === 'gram' || price.type === 'gram_offer'"
                        class="d-flex justify-content-between align-items-center px-0">
                    Lager
                    <span>{{price.gram}}</span>
                </b-list-group-item>
                <b-list-group-item
                        class="d-flex justify-content-between align-items-center px-0">
                    Hide?
                    <span>{{ (price.isHide === 'yes' ? 'yes' : 'no') }}</span>
                </b-list-group-item>
              <b-list-group-item
                        class="d-flex justify-content-between align-items-center px-0">
                Mit Rabatt anzeigen?
                <template v-if="isServer">
                  <span>{{ (price.priceGroup === 'offer' ? 'Discount' : 'Single prise') }}</span>
                </template>
                <template v-else>
                  <span>{{ (price.priceGroup ? 'yes' : 'no') }}</span>
                </template>
                </b-list-group-item>
            </b-list-group>

            <template v-if="isServer">
                <b-button class="mr-2" variant="danger" @click="deletePriceServer(price.id)">delete</b-button>
                <b-button variant="info" @click="editPrice(price)">edit</b-button>
            </template>
            <template v-else>
                <b-button variant="danger" @click="removePriceItem(price.id)">delete</b-button>
            </template>
        </b-card>
    </div>
</template>

<script>
    import Http from '../../../Services/HttpService/HttpService'
    import Notification from '../../../Services/Notification/Nottification'
    import {EventBus} from "../../../Services/Eventbus/event-bus";

    export default {
        name: "Price",
        props: {
            prices:{
                type: Array,
                default: null
            },
            price: {
                type: Object,
                default: null
            },
            isServer: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                editPriceItem: null
            }
        },
        methods: {
            isPriceGram(myItem) {
                return myItem.type === 'gram' || myItem.type === 'gram_offer';
            },
            isPriceOffer(myItem) {
                return myItem.type === 'single_price_offer' || myItem.type === 'gram_offer';
            },
            removePriceItem(id) {
                let item = this.prices.find(item => item.id === id);
                if (item) {
                    this.prices.splice(this.prices.indexOf(item), 1);
                }
            },
            deletePriceServer(id) {
                if (confirm(this.$t('alertText'))) {
                    this.$Progress.start();
                    Http.get(Http.apiurlV2() + 'product/price/delete/' + id)
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                EventBus.$emit('refreshProduct', 'yes');
                                Notification.success(response.data.message)
                            } else {
                                Notification.success(response.data.message)
                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }
            },
            editPrice(item) {
                this.editPriceItem = item;
                EventBus.$emit('updatePriceItem', this.editPriceItem)
            },
        },
    }
</script>

<style scoped>

</style>